// Renders a human-readable sentence for an activity log entry.
// Kept in a small module so it can be unit-tested independently.

function q(s) {
    if (!s) return "";
    return `"${s}"`;
}

export function describeActivity(entry) {
    if (!entry) return "";
    const a = entry.action || "";
    const label = q(entry.target_label);
    const d = entry.details || {};

    switch (a) {
        case "auth.login":
            return "signed in";
        case "auth.login_failed":
            return `failed sign-in attempt for ${d.email || "unknown"}${d.reason === "bad_password" ? " (wrong password)" : d.reason === "unknown_email" ? " (email not registered)" : ""}`;
        case "auth.password_changed":
            return "changed their password";

        case "template.created":
            return `created template ${label}`;
        case "template.updated": {
            const fields = Array.isArray(d.changed) ? d.changed.filter((f) => f !== "updated_at").join(", ") : "";
            return `edited template ${label}${fields ? ` (${fields})` : ""}`;
        }
        case "template.deleted":
            return `deleted template ${label}`;
        case "template.duplicated":
            return `duplicated template ${label}${d.source_name ? ` from ${q(d.source_name)}` : ""}`;

        case "category.created":
            return `added category ${label}`;
        case "category.renamed":
            return `renamed category ${q(d.from)} → ${q(d.to)}`;
        case "category.deleted":
            return `deleted category ${label}`;

        case "brand.created":
            return `added brand ${label}`;
        case "brand.updated":
            return `updated brand ${label}${Array.isArray(d.changed) && d.changed.length ? ` (${d.changed.join(", ")})` : ""}`;
        case "brand.deleted":
            return `deleted brand ${label}`;

        case "logo.uploaded":
            return `uploaded a logo for ${label}${d.filename ? ` (${d.filename})` : ""}`;
        case "logo.set_active":
            return `set active logo for ${label}${d.filename ? ` — ${d.filename}` : ""}`;
        case "logo.height_changed":
            return `changed logo height for ${label} to ${d.height}px`;
        case "logo.deleted":
            return `deleted a logo from ${label}${d.filename ? ` (${d.filename})` : ""}`;

        case "user.invited":
            return `invited ${label}${d.email ? ` (${d.email})` : ""} as ${d.access_level || "adviser"}`;
        case "user.role_changed":
            return `changed ${label} from ${d.from || "?"} to ${d.to || "?"}`;
        case "user.invite_resent":
            return `re-sent invite to ${label}`;
        case "user.removed": {
            const t = d.templates_transferred || 0;
            return `removed ${label}${t ? ` — ${t} template${t === 1 ? "" : "s"} transferred` : ""}`;
        }
        default:
            return a;
    }
}

// Coarse-grained categories used by the UI filter.
export const ACTIVITY_CATEGORIES = [
    { key: "all", label: "All activity", prefixes: [] },
    { key: "templates", label: "Templates", prefixes: ["template."] },
    { key: "users_auth", label: "Users & auth", prefixes: ["user.", "auth."] },
    { key: "brands_categories", label: "Brands & categories", prefixes: ["brand.", "category.", "logo."] },
];

// Colour hint for the small category pill on each row.
export function actionCategory(action) {
    if (!action) return "other";
    if (action.startsWith("template.")) return "templates";
    if (action.startsWith("user.") || action.startsWith("auth.")) return "users_auth";
    if (action.startsWith("brand.") || action.startsWith("category.") || action.startsWith("logo.")) return "brands_categories";
    return "other";
}
